import { useContext } from "react";
import get from "lodash.get";
import { DataContext } from "contexts/DataContext";

const useLinkRelValue = (href: string, linktype = "url"): string => {
  const whiteListDomains = get(useContext(DataContext), "whiteListDomains", []);
  const isWhitelisted = whiteListDomains.some(({ value: domain }) => href.includes(domain));
  const isInternal = linktype === "story";
  const relValue = isWhitelisted || isInternal ? "noopener noreferrer" : "nofollow";

  return relValue;
};

export default useLinkRelValue;
